<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CH-T"><strong>Composites and Further Special Effects</strong></h1>
<p class="CH-INTRO1">In many ways, Photoshop was designed to allow the user to make sophisticated montages and composites. Unlike traditional photography, you are now able to make very accurate selections, which makes the task of importing elements from one file into another considerably easier. It is important that you carefully note the details of each of your files to ensure that, should you wish to make a composite, the elements match in terms of lighting, colour temperature and viewpoint.</p>
<p class="Image-C"><img alt="" src="OEBPS/images/6-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01.vue?128db86c